import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { useForm, SubmitHandler } from 'react-hook-form';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// components

import { GIButton, Modal } from 'app-components';

//types

import type { CountyZip, SearchResultProps } from './useGaep';

// hooks

import useGaep from './useGaep';

// styles

const StyledFormContainer = styled.div`

    padding-top: 3%;

    .fields {
      display: flex;
      flex-direction: row;
      column-gap: 10%;
    }

    .label {
      padding: 2% 0 2% 0;
      font-size: 2rem;
    }

    .btnContainer {
      padding-top: 5%;
    }
`;

// props

interface ShopByZipcodeModalProp {
    show: boolean;
    counties: CountyZip[] | null;
    zipcode: string | null;
    onHide: () => void;
    onSearch: (zipcode: string, countycode?: CountyZip | null) => void;
}

type Inputs = {
    zipcode: string;
}

const ShopByZipcodeModal = (props: ShopByZipcodeModalProp) => {

    const { counties, show, zipcode, onHide, onSearch } = props;
    const { register, handleSubmit, formState: { errors } } = useForm<Inputs>();
    const { validateZip } = useGaep();
    const [selectedCounty, setSelectedCounty] = useState<CountyZip | null>(null);
    const [countiesList, setCountiesList] = useState<CountyZip[] | null>(null);
    const [countryError, setCountryError] = useState<Boolean>(false);

    useEffect(() => {
        setCountiesList(counties);
    }, [props.counties]);

    const onSubmit: SubmitHandler<Inputs> = async (inputFormData) => {
        // if there are more than 1 county, users must select a county
        if (countiesList && countiesList.length > 1) {
            if (selectedCounty) {
                onSearch(inputFormData.zipcode, selectedCounty);
            } else {
                setCountryError(true);
            }
        } else {
            const res: SearchResultProps = await validateZip(inputFormData.zipcode);
            if (res.counties.length > 1) {
                setCountiesList(res.counties);
            } else {
                // returns 0 or 1 county code
                onSearch(inputFormData.zipcode, undefined);
            }
        }
    }

    const onHandleCountyChange = (selectedOption: CountyZip) => {
        setSelectedCounty(selectedOption);
    }

    const onChange = (e) => {
        if (e.target.value && e.target.value.length === 5) {
            handleSubmit(onSubmit)();
        }
    }

    if (!show) {
        return null;
    }

    return (
        <Modal id='carriers_search_by_zip_modal'>
            <Modal.Header id='carriers_search_by_zip_header_modal' titleId='gaep.ins_company.shop_with_an_ins_company' onHide={onHide} />
            <Modal.Body>
                <h2><FormattedMessage id="gaep.ins_company.find_ins_companies" /></h2>
                <StyledFormContainer>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='fields'>
                            <div>
                                <label htmlFor='carriers_zipcode' className='label fields'>
                                    <FormattedMessage id="gaep.ins_company.zipcode" />
                                </label>

                                <input id='carriers_zipcode' type="number" {...register('zipcode', { required: true, value: zipcode || '', onChange: onChange })} />
                                {errors.zipcode && <div className='grid-row grid-col-12 error__msg__container'>
                                    <span className='shown error--msg'>
                                        <em>

                                            <FontAwesomeIcon
                                                icon
                                                ="exclamation"
                                            />

                                        </em>
                                        <FormattedMessage id='ga.agents.form.error.required' />
                                    </span>
                                </div>}

                            </div>
                            {
                                countiesList && countiesList.length > 0 &&
                                <div>
                                    <div className='label'>
                                        <FormattedMessage id='gaep.search.county' />
                                    </div>
                                    <div>
                                        <Select
                                            value={selectedCounty}
                                            closeMenuOnSelect={true}
                                            options={countiesList}
                                            defaultValue={countiesList[0]}
                                            onChange={onHandleCountyChange}
                                        />
                                        {countryError && <div className='grid-row grid-col-12 error__msg__container'>
                                            <span className='shown error--msg'>
                                                <em>

                                                    <FontAwesomeIcon
                                                        icon
                                                        ="exclamation"
                                                    />

                                                </em>
                                                <FormattedMessage id='ga.agents.form.error.required' />
                                            </span>
                                        </div>}
                                    </div>
                                </div>
                            }
                        </div>
                        <div className='btnContainer'>
                            <GIButton id='carriers_search_by_zip_find_btn' labelId='gaep.ins_company.find' />
                        </div>
                    </form>
                </StyledFormContainer>
            </Modal.Body>
        </Modal>
    )
}

export default ShopByZipcodeModal;